import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "hhn-commons";
import { FormControlLayout } from "./AddPatientGroup.style";

type SocStarterFieldProps = {
  socStarter: string;
  setRole: (role: string) => void;
  groupInfo?: unknown;
  patientStatus: number;
};
export const SocStarterField = ({
  socStarter,
  setRole,
  groupInfo,
  patientStatus,
}: SocStarterFieldProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  const isSocFieldDisabled = (): boolean => {
    return !!groupInfo && patientStatus !== 1 && patientStatus !== 2;
  };

  return (
    <FormControlLayout data-testid="soc-starter-field">
      <FormLabel id="socStarter">{tNs("socLabel")}</FormLabel>
      <RadioGroup
        row
        name="socRow"
        value={socStarter}
        onChange={e => setRole(e.target.value)}
        data-testid="socStarterOptions"
      >
        <FormControlLabel
          data-testid="SN-label"
          value="SN"
          control={<Radio />}
          label="SN"
          disabled={isSocFieldDisabled()}
        />
        <FormControlLabel
          data-testid="PT-label"
          value="PT"
          control={<Radio />}
          label="PT"
          disabled={isSocFieldDisabled()}
        />
        <FormControlLabel
          data-testid="SLP-label"
          value="SLP"
          control={<Radio />}
          label="SLP"
          disabled={isSocFieldDisabled()}
        />
        <FormControlLabel
          data-testid="OT-label"
          value="OT"
          control={<Radio />}
          label="OT"
          disabled={isSocFieldDisabled()}
        />
      </RadioGroup>
    </FormControlLayout>
  );
};
